export default __webpack_public_path__ + "static/media/overreach2.caa5ea25.png";